"use client";

import { ChevronDown, ChevronUp } from "lucide-react";
import { useTranslations } from "next-intl";
import { useEffect, useRef, useState } from "react";

interface MsPropertyDetailsDescriptionProps {
	children: React.ReactNode;
}

const MsPropertyDetailsDescription: React.FC<MsPropertyDetailsDescriptionProps> = ({ children }) => {
	const t = useTranslations("ms");
	const ref = useRef<HTMLDivElement>(null);
	const [collapsed, setCollapsed] = useState(true);
	const [height, setHeight] = useState(100);

	useEffect(() => {
		if (!ref.current) return;

		if (collapsed) {
			setHeight(100);
		} else {
			setHeight(ref.current.scrollHeight);
		}
	}, [collapsed]);

	return (
		<div>
			<h2 className="mb-4">{t("description.title")}</h2>

			<div>
				<div
					ref={ref}
					style={{ maxHeight: height + "px" }}
					className="relative overflow-hidden whitespace-pre-line transition-[max-height] duration-400"
				>
					{children}

					{collapsed ? (
						<div className="pointer-events-none absolute bottom-0 left-0 right-0 h-20 bg-linear-to-t from-(--bg-body) to-transparent"></div>
					) : null}
				</div>

				<span className="cursor-pointer flex items-center gap-2 text-(--ms-color-primary) mt-2" onClick={() => setCollapsed(!collapsed)}>
					{t(collapsed ? "description.toggle-more" : "description.toggle-less")}
					{collapsed ? <ChevronDown className="size-4" /> : <ChevronUp className="size-4" />}
				</span>
			</div>
		</div>
	);
};

export default MsPropertyDetailsDescription;
